import { Controller } from "@hotwired/stimulus"

// checkbox "Transakcja trójstronna" (pl, widoczny gdy zaznaczone odwrotne obciążenie): wymusza
// stawkę "np" i wyszarza "eksport towarów UE", parytet z bootstrapem
// (_form_triangular_transaction_pl.js.erb)
export default class extends Controller {
  static targets = ["checkbox"]
  static outlets = ["invoice--tax-rate", "invoice--reverse-charge"]
  static values = { designation: String }

  connect() {
    if (this.checkboxTarget.checked) this.apply(true)
  }

  toggle(event) {
    this.apply(event.target.checked)
  }

  apply(checked) {
    const taxRate = this.invoiceTaxRateOutlet

    if (checked) {
      taxRate.lockTax("triangular-transaction")
      taxRate.lockTaxTo("np")
      taxRate.selectExportServiceNaTaxKind()
      taxRate.setNpTaxKindInnerDisabled(true)
    } else {
      taxRate.unlockTax("triangular-transaction")
      taxRate.setNpTaxKindInnerDisabled(false)

      if (this.hasInvoiceReverseChargeOutlet && this.invoiceReverseChargeOutlet.checkboxTarget.checked) {
        this.invoiceReverseChargeOutlet.apply(true)
      }
    }

    this.dispatch("designationToggled", { detail: { code: this.designationValue, checked } })
  }

  handleReverseChargeChanged(event) {
    this.element.classList.toggle("hidden", !event.detail.checked)

    if (!event.detail.checked && this.checkboxTarget.checked) {
      this.checkboxTarget.checked = false
      this.apply(false)
    }
  }
}
